/** Trocar ou tirar a imagem da viagem, em Configurações (item 22). */
import { useRef, useState } from 'react';

import { Icon } from '../../ui/icons';
import { RecorteDeImagem } from '../../ui/RecorteDeImagem';
import { FotoAvatar } from '../perfil/FotoAvatar';
import { useCapaDaViagem, useTrocarCapa } from './capa';

export function CapaDaViagem({ tripId, nome, podeEditar }: { tripId: string; nome: string; podeEditar: boolean }) {
  const capa = useCapaDaViagem(tripId);
  const { trocar, tirar } = useTrocarCapa(tripId);
  const arquivo = useRef<HTMLInputElement>(null);
  const [bruta, setBruta] = useState<File | null>(null);

  return (
    <div className="viagens__capa-escolha">
      <button type="button" className="perfil__foto-botao" onClick={() => arquivo.current?.click()} disabled={!podeEditar || trocar.isPending} aria-label="Trocar a imagem da viagem" data-testid="capa-escolher">
        <FotoAvatar nome={nome || '?'} url={capa.data?.url} tamanho={64} className="perfil__avatar" />
        {podeEditar && <span className="perfil__foto-lapis" aria-hidden="true"><Icon name="editar" size={12} /></span>}
      </button>
      <span className="viagens__capa-texto">
        <span className="rk__linha-nome">Imagem da viagem</span>
        <span className="rk__linha-familia">{trocar.isPending ? 'Enviando…' : capa.data?.url ? 'Aparece em Minhas viagens' : 'Sem imagem · a inicial aparece no lugar'}</span>
        {podeEditar && capa.data?.url && (
          <button type="button" className="nv-btn nv-btn--chip" onClick={() => tirar.mutate()} disabled={tirar.isPending} data-testid="capa-tirar">
            Tirar
          </button>
        )}
        {(trocar.isError || tirar.isError) && <span className="auth-error" role="alert">Não foi possível mudar a imagem agora.</span>}
      </span>
      <input ref={arquivo} type="file" accept="image/*" hidden data-testid="capa-arquivo" onChange={(e) => setBruta(e.target.files?.[0] ?? null)} />
      {bruta && (
        <RecorteDeImagem
          arquivo={bruta}
          titulo="Imagem da viagem"
          ocupado={trocar.isPending}
          onCancelar={() => setBruta(null)}
          onConfirmar={(blob) => {
            void trocar.mutateAsync(blob).then(() => setBruta(null));
          }}
        />
      )}
    </div>
  );
}
